import React from 'react'
import "./IMLeadtable.css"

const IMLeadTable = ({heads, data}) => {
  return (
    <div class="contaidner center IMLeadTable">
	<table>
		<thead>
			<tr>
				{heads.map((head, i) =><th>{head.displayName}</th>)}
			</tr>
		</thead>
		<tbody>

            {data.map((lead, i) =><tr>
                {heads.map((head, i) =><th>{lead[head.key]?lead[head.key]:lead[head.key2]}</th>)}
            </tr>)}
		</tbody>
	</table>
</div>
  )
}

export default IMLeadTable